import { RootState } from 'shared/store/store'
import {
  ConfigProcessingEnum,
  IEmailConfig,
} from 'Modules/Communication/shared/models/EmailConfig'

export interface SystemState {
  emailSettings: {
    configuration: {
      data: IEmailConfig | null
      loading: boolean
      error: unknown
      processing: ConfigProcessingEnum | null
      processingError: ConfigProcessingEnum | null
    }
  }
}

export const getEmailConfiguration = (state: RootState) =>
  state.emailSettings.configuration
